import { HLayout } from '@sleepstation/components-layouts'
import {
  backgroundColor,
  stylesIfPropTrue,
} from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import { times } from 'ramda'
import React from 'react'
import styled, { css } from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(HLayout).attrs({ spacing: 0.4 })``

const Item = styled.div`
  border-radius: 50%;
  ${backgroundColor(`bodyTertiary`)}
  width: 8px;
  height: 8px;
  transition:
    transform 0.5s ease-out,
    background-color 0.5s ease-out;

  ${stylesIfPropTrue(
    `isSelected`,
    css`
      ${backgroundColor(`body`)}
      transform: scale(1.25);
      transition:
        transform 0.25s ease-out,
        background-color 0.25s ease-out;
    `
  )}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ProgressIndicator = ({ count, currentIndex }) => (
  <Layout>
    {times(
      (idx) => (
        <Item isSelected={idx === currentIndex} key={`indicator ${idx}`} />
      ),
      count
    )}
  </Layout>
)

ProgressIndicator.propTypes = {
  count: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired,
}

export default ProgressIndicator
